// Gives a picture of what the store looks like... great for people to understant your app
export default {
	mandatories: {
		company: '',
		associates: 0,
		contactName: '',
		contactEmail: '',
		contactPhone: '',
		projectName: '',
		projectSqFt: 0,
		representitiveName: '',
		representitiveEmail: '',
		notes: '',
		currentLine: 0
	},
	budgets: [],
	lineItems: [],
	estimates: {}
}


// WEBPACK FOOTER //
// ./src/reducers/initialState.js